/** Global wheel-table header + ticker-column shading (web + mobile column picker). */

const STORAGE_KEY = "sfe-table-shading-v1";

export const TABLE_SHADING_CHANGED_EVENT = "sfe-table-shading-changed";

export function isTableShadingEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function setTableShadingEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.setItem(STORAGE_KEY, "1");
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore quota / private mode */
  }
  syncTableShadingBodyClass();
  document.dispatchEvent(new CustomEvent(TABLE_SHADING_CHANGED_EVENT));
}

export function syncTableShadingBodyClass(): void {
  document.body.classList.toggle("sfe-table-shading-on", isTableShadingEnabled());
}

export function renderTableShadingPrefRow(checked: boolean): string {
  return `
    <div class="sfe-column-settings-row sfe-table-shading-pref-row">
      <label class="sfe-column-settings-check">
        <input type="checkbox" data-table-shading-toggle ${checked ? "checked" : ""} aria-label="Table shading (all tabs)" />
      </label>
      <span class="sfe-column-settings-name">Table shading (all tabs)</span>
    </div>`;
}
